import React from 'react';
import VideoChatContain from '../../Componant/Chat/VideoChat';

const VideoChat = () => {
  return (
    <div className='page-body'>
      <VideoChatContain />
    </div>
  );
};

export default VideoChat;
